/* global MutationObserver */
import ApplicationController from '../application_controller'

class DisableAutocompleteController extends ApplicationController {
  connect () {
    this.disableAutocomplete()
    this.observeFormChanges()
  }

  disableAutocomplete () {
    const form = this.element.querySelector('form') || this.element
    form.setAttribute('autocomplete', 'off')

    const inputs = form.querySelectorAll(
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]), textarea, select'
    )

    inputs.forEach(input => {
      input.setAttribute('autocomplete', 'new-password')
      input.setAttribute('list', 'autocompleteOff')
    })
  }

  observeFormChanges () {
    const form = this.element.querySelector('form') || this.element
    const observer = new MutationObserver(() => {
      this.disableAutocomplete()
    })

    observer.observe(form, {
      childList: true,
      subtree: true
    })
  }
}

export default DisableAutocompleteController
